import { createBrowserRouter } from 'react-router-dom'
import Expired from '../components/Expired'
import Tracking from '../components/Tracking'
import ReverseTracking from '../components/Reverse/ReverseTracking'

export const router = createBrowserRouter([
  {
    path: '/expirado',
    element: <Expired />
  },
  {
    path: '/:uuid',
    element: <Tracking />
  },
  {
    path: '/reversa/:reverseUUID',
    element: <ReverseTracking />
  },
  {
    path: '/',
    element: <Expired />
  }
])
